import { render, staticRenderFns } from "./listing-properti.vue?vue&type=template&id=67349dc4"
import script from "./listing-properti.vue?vue&type=script&lang=js"
export * from "./listing-properti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports